var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"main-header"},[_c('current-timezone'),_vm._v(" "),_c('voxy-organization-filter'),_vm._v(" "),_c('conversations-button')],1)}
var staticRenderFns = []

export { render, staticRenderFns }